if (!customElements.get('axivelle-product')) {
  customElements.define('axivelle-product', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.cancelReviewMotion();
      this.reviewDrag = null;
      this.reviewResizeObserver?.disconnect();
      this.ratingResizeObserver?.disconnect();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.setupShipping(signal);
      this.setupOfferPrice(signal);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-review-video-play]');
        if (!button) return;
        const card = button.closest('.ax1__video');
        const template = card.querySelector('[data-review-video-template]');
        const video = template.content.querySelector('video').cloneNode(true);
        this.querySelectorAll('.ax1__video video').forEach(other => other.pause());
        button.replaceWith(video);
        video.addEventListener('play', () => {
          this.querySelectorAll('.ax1__video video').forEach(other => { if (other !== video) other.pause(); });
        }, { signal });
        video.focus();
        video.play().catch(() => { /* Native controls remain available if playback is blocked. */ });
      }, { signal });
      const nutrition = this.querySelector('[data-nutrition-dialog]');
      const nutritionTrigger = this.querySelector('[data-nutrition-open]');
      if (nutrition && nutritionTrigger) {
        nutritionTrigger.addEventListener('click', () => nutrition.showModal(), { signal });
        nutrition.querySelector('[data-nutrition-close]').addEventListener('click', () => nutrition.close(), { signal });
        nutrition.addEventListener('click', event => {
          const rect = nutrition.getBoundingClientRect();
          if (event.target === nutrition && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) nutrition.close();
        }, { signal });
        nutrition.addEventListener('close', () => nutritionTrigger.focus({ preventScroll: true }), { signal });
      }
      this.setupRatingFit(signal);
      this.gallery = this.querySelector('[data-gallery]');
      this.reviews = this.querySelector('[data-reviews]');
      this.addEventListener('click', (event) => {
        const control = event.target.closest('button');
        if (!control) return;
        if (control.dataset.slide !== undefined) this.move(this.gallery, Number(control.dataset.slide));
        if (control.dataset.galleryStep) this.move(this.gallery, this.index(this.gallery) + Number(control.dataset.galleryStep));
        if (control.dataset.reviewStep) this.move(this.reviews, this.index(this.reviews) + Number(control.dataset.reviewStep));
      }, { signal });
      for (const track of [this.gallery, this.reviews]) {
        if (!track) continue;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(track.frame);
          track.frame = requestAnimationFrame(() => {
            const index = this.index(track);
            if (track === this.gallery) this.updateGalleryControls();
            else this.updateReviewControls();
            track.querySelectorAll('video').forEach((video) => {
              if (video.closest('.ax1__slide') !== track.children[index]) video.pause();
            });
          });
        }, { signal, passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = this.index(track) + (event.key === 'ArrowRight' ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = track.children.length - 1;
          this.move(track, next);
        }, { signal });
      }
      this.updateGalleryControls();
      if (this.reviews) {
        const track = this.reviews;
        this.updateReviewControls();
        this.reviewResizeObserver = new ResizeObserver(() => this.updateReviewControls());
        this.reviewResizeObserver.observe(track);
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button, input')) return;
          this.cancelReviewMotion();
          this.reviewDrag = { pointerId: event.pointerId, x: event.clientX, left: track.scrollLeft };
          track.style.scrollSnapType = 'none';
          track.dataset.dragging = '';
          track.setPointerCapture(event.pointerId);
          event.preventDefault();
        }, { signal });
        track.addEventListener('pointermove', (event) => {
          if (!this.reviewDrag || event.pointerId !== this.reviewDrag.pointerId) return;
          track.scrollLeft = this.reviewDrag.left - (event.clientX - this.reviewDrag.x);
        }, { signal });
        const finishDrag = (event) => {
          if (!this.reviewDrag || event.pointerId !== this.reviewDrag.pointerId) return;
          this.reviewDrag = null;
          delete track.dataset.dragging;
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          this.move(track, this.index(track));
        };
        for (const name of ['pointerup', 'pointercancel', 'lostpointercapture']) track.addEventListener(name, finishDrag, { signal });
      }
      const mount = this.querySelector('[data-kaching-bundle]');
      const submit = this.querySelector('[data-bundle-submit]');
      const status = this.querySelector('[data-bundle-status]');
      if (mount && submit) {
        const ready = () => {
          const widget = Array.from(mount.querySelectorAll('kaching-bundles-block')).find((element) => element.getAttribute('deal-block-id') === mount.dataset.dealId);
          if (!widget?.querySelector('.kaching-bundles__block--loaded')) return;
          submit.disabled = submit.dataset.productAvailable !== 'true';
          if (status) status.hidden = true;
          clearTimeout(this.bundleTimer);
          this.bundleObserver?.disconnect();
        };
        this.bundleObserver = new MutationObserver(ready);
        this.bundleObserver.observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'deal-block-id'] });
        this.bundleTimer = setTimeout(() => {
          if (status && !status.hidden) status.textContent = status.dataset.error;
        }, 15000);
        ready();
      }
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.ax1__slide, .ax1__review');
        if (slide) this.move(slide.parentElement, Array.from(slide.parentElement.children).indexOf(slide));
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      }, { signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.reviewDrag = null;
      this.bundleObserver?.disconnect();
      this.offerPriceObserver?.disconnect();
      this.reviewResizeObserver?.disconnect();
      this.ratingResizeObserver?.disconnect();
      this.cancelReviewMotion();
      clearTimeout(this.bundleTimer);
      clearTimeout(this.shippingTimer);
      if (this.gallery) cancelAnimationFrame(this.gallery.frame);
      if (this.reviews) cancelAnimationFrame(this.reviews.frame);
    }
    setupOfferPrice(signal) {
      const display = this.querySelector('[data-offer-price]');
      const mount = this.querySelector('[data-kaching-bundle]');
      if (!display || !mount) return;
      const bound = new WeakSet();
      const bind = () => {
        const widget = Array.from(mount.querySelectorAll('kaching-bundles-block')).find(element => element.getAttribute('deal-block-id') === mount.dataset.dealId);
        if (!widget || bound.has(widget) || typeof widget.pricing !== 'function') return;
        bound.add(widget);
        const update = () => {
          try {
            const { discountedPrice, fullPrice } = widget.pricing();
            const current = Number(discountedPrice?.amount);
            const original = Number(fullPrice?.amount);
            if (!Number.isFinite(current) || current < 0 || !discountedPrice?.formatted) {
              display.hidden = true;
              return;
            }
            display.querySelector('[data-offer-current]').textContent = discountedPrice.formatted;
            const compare = display.querySelector('[data-offer-compare]');
            const badge = display.querySelector('[data-offer-savings]');
            const hasSaving = Number.isFinite(original) && original > current;
            compare.hidden = !hasSaving;
            badge.hidden = !hasSaving || !badge.dataset.template;
            compare.textContent = hasSaving ? fullPrice.formatted : '';
            badge.textContent = hasSaving ? badge.dataset.template.replaceAll('[percentage]', `${Math.round((original - current) / original * 100)}%`) : '';
            display.hidden = false;
          } catch {
            display.hidden = true;
          }
        };
        for (const name of ['items-changed', 'deal-bar-selected', 'variants-changed', 'variant-selected']) {
          widget.addEventListener(name, () => queueMicrotask(update), { signal });
        }
        update();
      };
      this.offerPriceObserver?.disconnect();
      this.offerPriceObserver = new MutationObserver(bind);
      this.offerPriceObserver.observe(mount, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'deal-block-id'] });
      document.addEventListener('kaching-bundles-block-loaded', bind, { signal });
      bind();
    }
    setupRatingFit(signal) {
      const row = this.querySelector('.ax1__rating');
      if (!row) return;
      const text = row.querySelector('.ax1__rating-text');
      const stars = row.querySelector('.ax1__stars');
      const fit = () => {
        if (signal.aborted || !this.isConnected || !row.clientWidth) return;
        const desired = Number.parseFloat(getComputedStyle(row).fontSize);
        const gap = Number.parseFloat(getComputedStyle(row).columnGap) || 0;
        const available = row.clientWidth - stars.getBoundingClientRect().width - gap;
        text.style.whiteSpace = 'nowrap';
        text.style.fontSize = `${desired}px`;
        if (text.scrollWidth > available) {
          const size = Math.max(10, Math.floor(desired * (available - 1) / text.scrollWidth * 100) / 100);
          text.style.fontSize = `${Math.min(desired, size)}px`;
        }
        if (text.scrollWidth > available + 1) text.style.whiteSpace = 'normal';
      };
      fit();
      this.ratingResizeObserver = new ResizeObserver(fit);
      this.ratingResizeObserver.observe(row);
      document.fonts?.ready.then(fit);
      document.fonts?.addEventListener('loadingdone', fit, { signal });
    }
    shippingDate(today, days, skipWeekends) {
      const date = new Date(today);
      date.setHours(12, 0, 0, 0);
      let remaining = days;
      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        if (!skipWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) remaining--;
      }
      return date;
    }
    setupShipping(signal) {
      clearTimeout(this.shippingTimer);
      const shipping = this.querySelector('[data-shipping]');
      if (!shipping) return;
      const updateDate = () => {
        clearTimeout(this.shippingTimer);
        const today = new Date();
        const days = Math.max(1, Math.min(7, Number(shipping.dataset.processingDays) || 1));
        const date = this.shippingDate(today, days, shipping.dataset.skipWeekends === 'true');
        const time = shipping.querySelector('[data-shipping-date]');
        time.textContent = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        time.dateTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        const midnight = new Date(today);
        midnight.setHours(24, 0, 1, 0);
        this.shippingTimer = setTimeout(updateDate, midnight - today);
      };
      updateDate();
      document.addEventListener('visibilitychange', () => { if (!document.hidden) updateDate(); }, { signal });
      const flag = shipping.querySelector('[data-shipping-flag]');
      flag.addEventListener('error', () => { flag.hidden = true; }, { signal });
      if (shipping.dataset.detectCountry === 'true') this.loadShippingCountry(shipping, signal);
      else this.renderShippingCountry(shipping, shipping.dataset.currentCountry);
    }
    async loadShippingCountry(shipping, signal) {
      try {
        const response = await fetch(shipping.dataset.countryUrl, { credentials: 'same-origin', signal: AbortSignal.any([signal, AbortSignal.timeout(5000)]) });
        if (!response.ok) return;
        const data = await response.json();
        if (!signal.aborted && this.isConnected) this.renderShippingCountry(shipping, data?.detected_values?.country?.handle);
      } catch {
        return;
      }
    }
    renderShippingCountry(shipping, country) {
      const code = String(country || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(code)) return;
      const flag = shipping.querySelector('[data-shipping-flag]');
      shipping.querySelector('[data-shipping-country]').textContent = code;
      if (code !== shipping.dataset.currentCountry) flag.src = `https://flagcdn.com/w40/${code.toLowerCase()}.png`;
      flag.hidden = false;
      shipping.querySelector('[data-shipping-local]').hidden = false;
      shipping.querySelector('[data-shipping-fallback]').hidden = true;
    }
    index(track) {
      if (!track?.clientWidth) return 0;
      return Math.round(track.scrollLeft / this.step(track));
    }
    step(track) {
      return track.clientWidth + (Number.parseFloat(getComputedStyle(track).columnGap) || 0);
    }
    move(track, index) {
      if (!track) return;
      const next = Math.max(0, Math.min(index, track.children.length - 1));
      if (track === this.reviews) {
        this.moveReview(next);
        return;
      }
      track.scrollTo({ left: next * this.step(track), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateGalleryControls() {
      if (!this.gallery) return;
      const index = this.index(this.gallery);
      this.querySelectorAll('[data-gallery-step]').forEach((button) => {
        button.disabled = Number(button.dataset.galleryStep) < 0 ? index === 0 : index >= this.gallery.children.length - 1;
      });
      this.querySelectorAll('[data-slide]').forEach((button, i) => {
        button.setAttribute('aria-pressed', String(i === index));
        if (i !== index) return;
        const thumbnails = button.parentElement;
        const bounds = thumbnails.getBoundingClientRect();
        const target = button.getBoundingClientRect();
        if (target.left < bounds.left || target.right > bounds.right) {
          thumbnails.scrollTo({ left: thumbnails.scrollLeft + target.left - bounds.left - (bounds.width - target.width) / 2, behavior: 'instant' });
        }
      });
    }
    updateReviewControls() {
      if (!this.reviews) return;
      const index = this.index(this.reviews);
      this.reviews.dataset.index = String(index);
      this.querySelectorAll('[data-review-step]').forEach((button) => {
        button.disabled = Number(button.dataset.reviewStep) < 0 ? index === 0 : index >= this.reviews.children.length - 1;
      });
      Array.from(this.reviews.children).forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
      });
    }
    cancelReviewMotion() {
      cancelAnimationFrame(this.reviewAnimation);
      if (!this.reviews) return;
      this.reviews.style.removeProperty('scroll-snap-type');
      delete this.reviews.dataset.animating;
    }
    moveReview(index) {
      const track = this.reviews;
      this.cancelReviewMotion();
      const start = track.scrollLeft;
      const target = index * this.step(track);
      const duration = Number(track.dataset.transition) || 500;
      if (Math.abs(target - start) < 1 || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.scrollLeft = target;
        this.updateReviewControls();
        return;
      }
      track.style.scrollSnapType = 'none';
      track.dataset.animating = '';
      const began = performance.now();
      const tick = (now) => {
        const progress = Math.min(1, (now - began) / duration);
        track.scrollLeft = start + (target - start) * this.reviewEaseIn(progress);
        if (progress < 1) this.reviewAnimation = requestAnimationFrame(tick);
        else {
          this.cancelReviewMotion();
          track.scrollLeft = target;
          this.updateReviewControls();
        }
      };
      this.reviewAnimation = requestAnimationFrame(tick);
    }
    reviewEaseIn(progress) {
      if (progress <= 0 || progress >= 1) return progress;
      let low = 0;
      let high = 1;
      let time = progress;
      // Invert x for cubic-bezier(.42, 0, 1, 1), then evaluate y.
      for (let i = 0; i < 10; i++) {
        time = (low + high) / 2;
        const x = 1.26 * (1 - time) ** 2 * time + 3 * (1 - time) * time ** 2 + time ** 3;
        if (x < progress) low = time;
        else high = time;
      }
      return time ** 2 * (3 - 2 * time);
    }
  });
}
